import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ValidatedCollapseCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { andComp, propertyIs, entityIs } from '@bingads-webui-campaign-react/form-error';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { getLinkedInBidStrategyOptions } from '@bingads-webui-campaign-react/linkedin-utils';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/linkedin-data';
import { ValidatedBidStrategyDropdown, BidStrategyIcon } from '@bingads-webui-campaign-react/bid-strategy-component-v2';

import { BidStrategySkeleton } from '../components/skeletons';

const entityIsCampaign = entityIs(ERROR_ENTITY.Campaign);
const campaignBiddingSchemeProp = andComp(entityIsCampaign, propertyIs('BiddingScheme'));

const ServerValidatedBidStrategy = withControlErrorHandling(withUnvalidatedControlErrors(ValidatedBidStrategyDropdown, { filter: campaignBiddingSchemeProp }));

export const BidStrategyCard = ({ data, ...cardProps }) => {
  const i18n = useContext(I18nContext);

  const { campaignGoal, bidStrategy } = data || {};

  const bidStrategyOptions = useMemo(() => getLinkedInBidStrategyOptions(campaignGoal), [campaignGoal]);

  return (
    <ValidatedCollapseCard {...cardProps}>
      <FormCardBasicHeader
        title={i18n.getString(_TL_('Bid strategy'))}
        contentBefore={<BidStrategyIcon />}
        helpTopic="pop_BA_LinkedIn_BidStrategy"
        helpLabel={i18n.getString(_TL_('Click to learn more about bid strategy'))}
      />
      <FormCardBody>
        {data ? (
          <ServerValidatedBidStrategy
            validationProps={{
            data: { bidStrategy },
            field: 'bidStrategy',
          }}
            options={bidStrategyOptions}
            label={i18n.getString(_TL_('How do you want to manage your bids?'))}
          />
        ) : (
          <BidStrategySkeleton />
        )}
      </FormCardBody>
    </ValidatedCollapseCard>
  );
};

BidStrategyCard.propTypes = {
  data: PropTypes.shape({}).isRequired,
};
